import React from 'react';
import { getRecText } from '../../utils/recommendations';

const findSpendRow = (data, id) => {
  const rows = data?.spend_summary || data?.headcount_summary
    || data?.pp_spend_summary || data?.sed_spend_summary || [];
  return rows.find((r) => r.program === id || r.level === id || r.category === id);
};

// Plain, always-visible list of "how to improve" hints — same text as the inline
// RecommendationTip, surfaced instead of hidden behind a hover.
const Recommendations = ({ data }) => {
  const indicators = data?.indicators || [];
  const resultMap = Object.fromEntries((data?.results || []).map((r) => [r.id, r]));

  const items = indicators
    .map((ind) => {
      const r = resultMap[ind.id];
      const pts = r?.points ?? 0;
      if (pts >= ind.points) return null;
      const text = getRecText(ind, r?.actual ?? null, ind.points - pts, findSpendRow(data, ind.id));
      return text ? { id: ind.id, label: ind.label, text } : null;
    })
    .filter(Boolean);

  if (!items.length) return null;

  return (
    <div className="cd-recs">
      <div className="cd-blk">How to improve</div>
      <ul>
        {items.map((it) => (
          <li key={it.id}>
            <strong>{it.label}</strong>
            <span>{it.text}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Recommendations;
